import {toast, ToastContainer} from "react-toastify";
import HeadingSecondary from "../components/ HeadingSecondary";
import {NavLink} from "react-router-dom";
import LeftArrow from "../components/svg/setting/LeftArrow";
import VaccineWorld from "../components/svg/vaccination/VaccineWorld";
import VaccineIran from "../components/svg/vaccination/VaccineIran";
import i18n from "../i18n";

const Vaccination = () => {
  const notify = () => {
    toast.info("به زودی", {
      position: "top-center",
      autoClose: 1500,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      progress: undefined,
    });
  };
  return (
    <div className="margrave">
      <ToastContainer rtl/>
      <div className="u-margin-top-small-3-5 u-margin-bottom-small-2">
        <HeadingSecondary text="واکسیناسیون"/>
      </div>
      <div className="margrave__list u-margin-top-medium-5">
        <NavLink className="margrave__list__row" to={"/vaccination/vaccine-license"} onClick={() => {
          i18n.changeLanguage("en");
        }}>
          <div className="margrave__list__row__right">
            <span className="margrave__list__row__right--icon"
                  style={{
                    width: "36px",
                    height: "36px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                  }}
            >
              <VaccineWorld/>
            </span>
            <span className="margrave__list__row__right--title">
              دریافت گواهی واکسیناسیون بین المللی
            </span>
          </div>
          <div className="margrave__list__row__left">
            <span>
              <LeftArrow/>
            </span>
          </div>
        </NavLink>

        {/*<NavLink className="margrave__list__row" to={"/margrave/travel-permit"}>*/}
        {/*  <div className="margrave__list__row__right">*/}
        {/*    <span className="margrave__list__row__right--icon">*/}
        {/*      <Pilgrim />*/}
        {/*    </span>*/}
        {/*    <span className="margrave__list__row__right--title">*/}
        {/*   زائران اربعین*/}
        {/*    </span>*/}
        {/*  </div>*/}
        {/*  <div className="margrave__list__row__left">*/}
        {/*    <span>*/}
        {/*      <LeftArrow />*/}
        {/*    </span>*/}
        {/*  </div>*/}
        {/*</NavLink>*/}

        <NavLink className="margrave__list__row" to={"/vaccination/vaccine-license-internal"} onClick={() => {
          i18n.changeLanguage("fa");
        }}>
          <div className="margrave__list__row__right">
            <span
              className="margrave__list__row__right--icon"
              style={{width: "36px", height: "36px", display: "flex", justifyContent: "center", alignItems: "center"}}
            >
              <VaccineIran/>
            </span>
            <span className="margrave__list__row__right--title">
              دریافت گواهی واکسیناسیون داخلی
            </span>
          </div>
          <div className="margrave__list__row__left">
            <span>
              <LeftArrow/>
            </span>
          </div>
        </NavLink>

        <div className="margrave__list__row" onClick={notify}>
          <div className="margrave__list__row__right">
            <span
              className="margrave__list__row__right--icon"
              style={{width: "36px", height: "36px", display: "flex", justifyContent: "center", alignItems: "center"}}
            >
             XR
            </span>
            <span className="margrave__list__row__right--title">
              نتایج آزمایش
            </span>
          </div>
          <div className="margrave__list__row__left">
            <span>
              <LeftArrow/>
            </span>
          </div>
        </div>

      </div>
    </div>
  );
}

export default Vaccination;